import * as React from 'react';
import { Flex } from '../Layout';
import { StyleSheet, css } from 'aphrodite/no-important';

interface GeneralProps  {
    active: boolean;
    height?: string;
}

export const TrustpilotSpinner = (props: GeneralProps) => {
    const containerHeight = props.height || '20px';
    const spinner = (
        <Flex alignItems="center">
            <div style={{height: containerHeight}} className={css(styles.wrapper)}>
                <div className={css(styles.container)}>
                    <div className={css(styles.star, styles.one)}/>
                    <div className={css(styles.star, styles.two)}/>
                    <div className={css(styles.star, styles.three)}/>
                    <div className={css(styles.star, styles.four)}/>
                    <div className={css(styles.star, styles.five)}/>
                </div>
            </div>
        </Flex>
    );
    const styleModifier = props.active ? {} : {display: 'none'};
    return(
        <div style={styleModifier}>
            {spinner}
        </div>
    );
};

const spinnerOneAnimation = {
    '0%': { opacity: 1 },
    '12%': { opacity: 1 },
    '25%': { opacity: 1 },
    '36%': { opacity: 1 },
    '49%': { opacity: 0 },
    '61%': { opacity: 0 },
    '74%': { opacity: 0 },
    '86%': { opacity: 0 },
    '99%': { opacity: 0 },
};

const spinnerTwoAnimation = {
    '0%':  { opacity: 0 },
    '12%': { opacity: 1 },
    '25%': { opacity: 1 },
    '36%': { opacity: 1 },
    '49%': { opacity: 1 },
    '61%': { opacity: 0 },
    '74%': { opacity: 0 },
    '86%': { opacity: 0 },
    '99%': { opacity: 0 },
};

const spinnerThreeAnimation = {
    '0%':  { opacity: 0 },
    '12%': { opacity: 0 },
    '25%': { opacity: 1 },
    '36%': { opacity: 1 },
    '49%': { opacity: 1 },
    '61%': { opacity: 1 },
    '74%': { opacity: 0 },
    '86%': { opacity: 0 },
    '99%': { opacity: 0 },
};

const spinnerFourAnimation = {
    '0%' : { opacity: 0 },
    '12%': { opacity: 0 },
    '25%': { opacity: 0 },
    '36%': { opacity: 1 },
    '49%': { opacity: 1 },
    '61%': { opacity: 1 },
    '74%': { opacity: 1 },
    '86%': { opacity: 0 },
    '99%': { opacity: 0 },
};

const spinnerFiveAnimation = {
    '0%':   { opacity: 0 },
    '12%':  { opacity: 0 },
    '25%':  { opacity: 0 },
    '36%':  { opacity: 0 },
    '49%':  { opacity: 1 },
    '61%':  { opacity: 1 },
    '74%':  { opacity: 1 },
    '86%':  { opacity: 1 },
    '99%':  { opacity: 0 },
};

const styles = StyleSheet.create({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    container: {
        height: '20px',
        width: '110px',
        zIndex: 9999,
    },
    star: {
        willChange: 'opacity',
        position: 'relative',
        float: 'left',
        height: '100%',
        width: '18%',
        marginLeft: '2%',
        backgroundImage: 'url("//cdn.trustpilot.net/brand-assets/1.0.3/single-star-5.svg")',
        backgroundColor: '#13b57a',
        backgroundPosition: 'center center',
        backgroundSize: '110% 110%',
        backgroundRepeat: 'no-repeat',
        borderRadius: '10%',
        transition: 'opacity, 0.3s ease-in-out',
        opacity: 0,
        animationDuration: '.9s',
        animationIterationCount: 'infinite',
    },
    one: {
        animationName: spinnerOneAnimation,
    },
    two: {
        animationName: spinnerTwoAnimation,
    },
    three: {
        animationName: spinnerThreeAnimation,
    },
    four: {
        animationName: spinnerFourAnimation,
    },
    five: {
        animationName: spinnerFiveAnimation,
    },
});
